export const images = {
  logo: {
    maxWidth: '100%',
    display: 'block',
  },
}
